import React from "react";
import { motion } from "framer-motion";
import WhatsAppIcon, { whatsappUrl } from "./site/WhatsAppIcon";
import { FIRM } from "./site/_shared";

// Always-visible WhatsApp bubble — floats bottom-right on every page
export default function FloatingWhatsApp() {
  return (
    <motion.a
      href={whatsappUrl(FIRM.phone)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-button"
      aria-label="Chat with Charis & Mettle on WhatsApp"
      title="Chat on WhatsApp"
      initial={{ opacity: 0, scale: 0.6, y: 12 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.6, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="group fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-sage-900/25 transition-transform duration-300 hover:scale-105"
    >
      {/* soft pulse ring, stills on hover */}
      <span
        aria-hidden="true"
        className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping [animation-duration:2.5s] group-hover:opacity-0"
      />
      <WhatsAppIcon className="relative h-7 w-7" />
    </motion.a>
  );
}
